import React from "react";
import styled from "styled-components";
import {  useNavigate } from "react-router-dom";
import { GrLinkPrevious } from "react-icons/gr";

const UnderConstruction = () => {

  const navigate = useNavigate();
  return (
    <Container>
      <Message>🚧 Page Under Construction 🚧</Message>
      <SubMessage>We are working hard to ensure this page is fully functional in the next few days . Stay tuned!</SubMessage>

      <button onClick={() => {navigate(-1);}}><GrLinkPrevious size={12}/>Take me back</button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f8f9fa;
  text-align: center;
  font-family: Arial, sans-serif;

  button {
  margin-top: 3rem;
  background-color: #f8f9fa;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 1rem 1.5rem;
  border: none;
  color: #666;
  transition: all 0.3s ease-in-out;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    transform: translateY(-3px);
    text-decoration: underline;
    color: #333;
  }

  &:active {
    transform: translateY(1px);
    box-shadow: none;
  }
}

    

  
`;

const Message = styled.h1`
  font-size: 2rem;
  color: #333;
`;

const SubMessage = styled.p`
  font-size: 1.2rem;
  color: #666;
`;

export default UnderConstruction;